module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-orl_951e920.png";